import React, { useEffect, useState } from 'react';
import { CONFIG } from 'config/config';
import routes from 'config/config/routes';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import {
	IdentityDocumentsWrapper,
	NavigationWrapper,
	PickerHOC,
	Text,
	UiWrapper,
	UserWrapper,
	View,
} from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Footer from 'layout/components/Footer/Footer';
import Header from 'layout/components/Header/Header';

import BackNextButton from 'components/BackNextButton/BackNextButton';
import { MainModal } from 'components/MainModal/MainModal';

import { useGetError } from 'hooks/useGetError';
import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import arrowRigth from 'assets/images/svgStatic/arrowRigth.svg';

import { useCoinscrapPageView } from '../../hooks/useCoinscrapPageView';
import * as S from './styles';

const docToScan = 'dni';
// const docToScan = 'driverLicense'

export const IdentityBiometricSteps = PickerHOC({
	dniDocuments: {
		sourcePath: 'identityDocuments',
		sourceWrapper: IdentityDocumentsWrapper,
	},
	user: {
		sourceWrapper: UserWrapper,
		sourcePath: 'user',
	},
})(() => {
	/* eslint-disable-next-line */
	const {} = IdentityDocumentsWrapper.use();

	const { dniDocuments, user } = PickerHOC.use();
	const mainUserDni = dniDocuments.find((d) => d.main);
	const mainUserDniId = mainUserDni?.id;
	const { useHeader, useFooter, useLoading, openModal } = UiWrapper.use();
	const { navigateTo } = NavigationWrapper.use();
	const { t, i18n } = useTranslation();

	const [loading, setLoading] = useState();

	useFooter(<Footer />, []);
	useHeader(<Header />, []);
	useLoading(loading, { loadingMessage: loading });
	useInitialScrollToTop();
	useCoinscrapPageView('IdentityBiometricSteps');
	const getError = useGetError();

	// NAVIGATION
	const next = async () => {
		try {
			setLoading('Empezando el proceso...');
			CONFIG.routing.identityBiometricSteps.next(navigateTo);
		} catch (e) {
			setLoading(undefined);
			openModal(() => <MainModal type="error" text={getError(e)} />, {
				disableClickAway: true,
				closeButton: true,
				modalClass: isMobile ? 'modal-xl' : 'modal-main',
				key: 'modal-IdentityBiometricSteps-KO',
			});
		}
	};

	// EFFECTS
	useEffect(() => {
		console.log('💢 dniDocuments', dniDocuments);
		console.log('💢 mainUserDni', mainUserDni);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		(async () => {
			if (
				mainUserDni &&
				mainUserDni?.verificationStatus === 'VALID' &&
				(user?.metadata?.identityBiometricError === undefined ||
					user?.metadata?.identityBiometricError === null)
			) {
				setLoading('El usuario ya ha añadido su documento...');
				CONFIG.routing.identityBiometricSteps.nextAlreadyAdded(navigateTo);
			}
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [mainUserDni, mainUserDniId, navigateTo]);

	return (
		<Wrapper
			showTopSection
			step={3}
			title="Documento de identidad"
			subtitle="Vamos a iniciar el proceso de identificación por vídeo. Por favor, sigue las indicaciones que se te mostrarán en pantalla."
		>
			<View innerWrapperSt>
				<View itemStepSt>
					<S.StepCircle>
						<img src={arrowRigth} alt={'arrow icon'} />
					</S.StepCircle>
					<Text headingSecondarySt style={{ textAlign: 'left' }}>
						Hazte un selfie
					</Text>
				</View>
				<View>
					<Text
						stepsSt
						style={{
							textAlign: 'left',
							fontSize: isMobile ? 16 : 20,
							paddingLeft: isMobile ? 0 : 40,
						}}
					>
						La cámara frontal se activará automáticamente. Solo tendrás que centrar tu
						cara en el óvalo siguiendo las instrucciones que aparecerán en pantalla.
					</Text>
				</View>
				<View itemStepSt style={{ paddingTop: 20 }}>
					<S.StepCircle>
						<img src={arrowRigth} alt={'arrow icon'} />
					</S.StepCircle>
					<Text headingSecondarySt style={{ textAlign: 'left' }}>
						Captura el DNI/NIE por ambas caras
					</Text>
				</View>
				<View>
					<Text
						stepsSt
						style={{
							textAlign: 'left',
							fontSize: isMobile ? 16 : 20,
							paddingLeft: isMobile ? 0 : 40,
						}}
					>
						Ajusta tu DNI o NIE a la plantilla y sigue las instrucciones que te
						aparecerán en pantalla. Tendrás que repetir el proceso para ambas caras.
						También puedes adjuntar las fotos de tu documento si lo prefieres.
					</Text>
				</View>
			</View>
			<BackNextButton
				onClickBack={() =>
					navigateTo(routes.clientData, { queryParams: { internalStep: 4 } })
				}
				onClickNext={next}
			/>
		</Wrapper>
	);
});
